module.exports = __webpack_public_path__ + "img/home1.8ea9d72a.svg";